<template>
    <label v-if="titleElement" :class="titleClass" :for="id">
        <b>
            {{ titleElement }}
        </b>
        <b class="text-danger ms-1" v-if="isRequired">*</b>
    </label>

    <div :class="onHasIcon">
        <span v-if="iconDir === 'left'" class="input-group-text" :class="classIcon">
            <i :class="onGetIcon"></i>
        </span>

        <input
            :type="type"
            class="form-control vf-input"
            :class="totalyClass"
            :name="name"
            :id="id"
            :placeholder="placeholder"
            :isRequired="isRequired"
            :value="modelValue"
            :disabled="disabled"
            :ref="id"
            :valid="valid"
            @input="onUpdateModelValue"
            @change="onChange"
            :data-automation="`input-${ id }`"
        />

        <span v-if="iconDir === 'right'" class="input-group-text" :class="classIcon">
            <i :class="onGetIcon"></i>
        </span>
    </div>

    <span v-if="textBelow" :class="classBelow">{{ textBelow }}</span>
</template>

<script>
    import { onMounted, watch  } from 'vue';
    import { formProps } from '@/mixins';
    import { useVFInput } from '@/composables';

    export default {
        name: 'VFInput',
        mixins: [
            formProps
        ],
        setup(props, { emit }) {
            const {
                totalyClass,
                valid,
                onGetClasses,
                onGetIcon,
                onHasIcon,
                onUpdateModelValue
            } = useVFInput(props, emit);


            watch(() => valid.value, (newValue) => {
                totalyClass.value = onGetClasses(newValue);
            });

            onMounted(()=>{
                totalyClass.value = onGetClasses(valid.value);
            });

            const onChange = (event) => {
                emit('change', event.target.value); // Emitimos el evento change con el valor actualizado
            };

            return {
                totalyClass,
                valid,
                onGetIcon,
                onHasIcon,
                onChange,
                onUpdateModelValue
            };
        }
    };
</script>